var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":_vm.title,"actions":_vm.actions,"home":_vm.home},on:{"actionClick":_vm.actionClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }